import { API_APP_ID } from "../config";
import { getRegisterClientInfo } from "./browserClientInfo";
import { formatRegisterPhone } from "./buildRegisterPayload";

/**
 * Builds POST /api/v1/auth/player-login body (CRM Frontend Player API).
 * @see https://crm-api.inversatechnosoft.com/api/swagger/frontend#/Auth/post_api_v1_auth_player_login
 */
export async function buildLoginPayload(formPayload = {}) {
  const username =
    formPayload.username ||
    formatRegisterPhone(formPayload.countryCode, formPayload.phone);

  return {
    app_id: API_APP_ID,
    username,
    password: formPayload.password,
    client: await getRegisterClientInfo(),
  };
}
